import { call, put, takeLatest, select } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import {
  AUTH_SIGN_IN_INIT,
  AUTH_SIGN_IN_SUCCESS,
  AUTH_SIGN_IN_FAILED,
  AUTH_SIGN_UP_SUCCESS,
  AUTH_SIGN_UP_FAILED,
  AUTH_SIGN_UP_INIT,
  AUTH_STRIPE_CONNECT_INIT,
  AUTH_STRIPE_CONNECT_SUCCESS,
  AUTH_STRIPE_CONNECT_FAILED,
  UPDATE_USER_INIT,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILED,
  AUTH_VERIFY_EMAIL_FAILED,
  AUTH_VERIFY_EMAIL_SUCCESS,
  AUTH_VERIFY_EMAIL_INIT,
  AUTH_IMPERSONATE_INIT,
  AUTH_IMPERSONATE_FINISHED,
} from '../actionTypes';
import {
  impersonate as impersonateRequest,
  signIn as signInRequest,
  signUp as signUpRequest,
  stripeOAuth as stripeOAuthRequest,
} from '../../service/auth';
import { updateUser as updateUserRequest } from '../../service/user';
import { verifyEmail as verifyEmailRequest } from '../../service/auth';
import { makeSelectAuthToken } from '../selectors';
import { notify } from '../../utils/helper';

function* signIn({ payload: { callback, ...payload } }) {
  try {
    const res = yield call(signInRequest, payload);

    if (res && res.data) {
      notify('success', 'Logged in successfully.');

      localStorage.setItem(
        'authToken',
        res.data.data.token + ':' + res.data.data.sessionId
      );

      yield put({ type: AUTH_SIGN_IN_SUCCESS, user: res.data.data });

      typeof callback === 'function' && callback(res.data.data);

      if (res.data.data.verified) {
        yield put(push('/programs'));
      } else {
        yield put(push('/verify-email'));
      }
    } else {
      notify('error', 'Email or password is wrong.');

      yield put({ type: AUTH_SIGN_IN_FAILED });
    }
  } catch (err) {
    notify('error', 'Email or password is wrong.');

    yield put({ type: AUTH_SIGN_IN_FAILED });
  }
}

function* impersonate({ payload }) {
  try {
    const res = yield call(impersonateRequest, payload);

    if (res && res.data) {
      yield put({ type: AUTH_IMPERSONATE_FINISHED });
      notify('success', 'Impersonated successfully.');

      localStorage.setItem('authToken', res.data.data.token);

      yield put({ type: AUTH_SIGN_IN_SUCCESS, user: res.data.data });
      if (res.data.data.verified) {
        yield put(push('/programs'));
      } else {
        yield put(push('/verify-email'));
      }
    } else {
      yield put({ type: AUTH_IMPERSONATE_FINISHED });
      notify('error', 'Some info is invalid.');

      yield put({ type: AUTH_SIGN_IN_FAILED });
    }
  } catch (err) {
    yield put({ type: AUTH_IMPERSONATE_FINISHED });
    notify('error', 'Some info is invalid.');

    yield put({ type: AUTH_SIGN_IN_FAILED });
  }
}

function* signUp({ payload }) {
  try {
    const res = yield call(signUpRequest, payload);

    if (res && res.data) {
      localStorage.setItem('authToken', res.data.data.token);

      yield put({ type: AUTH_SIGN_UP_SUCCESS, user: res.data.data });
      yield put(push('/verify-email'));
    } else {
      yield put({ type: AUTH_SIGN_UP_FAILED });
    }
  } catch (err) {
    yield put({ type: AUTH_SIGN_UP_FAILED });
  }
}

function* stripeOAuth({ payload }) {
  try {
    const token = yield select(makeSelectAuthToken());
    const res = yield call(stripeOAuthRequest, payload, token);

    if (res && res.data) {
      yield put({ type: AUTH_STRIPE_CONNECT_SUCCESS });
    } else {
      yield put({ type: AUTH_STRIPE_CONNECT_FAILED });
    }
  } catch (err) {
    yield put({ type: AUTH_STRIPE_CONNECT_FAILED });
  }
}

function* updateUser({ payload: { id, ...data } }) {
  try {
    const res = yield call(updateUserRequest, id, data);

    if (res && res.data) {
      yield put({ type: UPDATE_USER_SUCCESS, user: res.data.data });
    } else {
      yield put({
        type: UPDATE_USER_FAILED,
        error: 'Failed to update user info.',
      });
    }
  } catch (err) {
    yield put({
      type: UPDATE_USER_FAILED,
      error: 'Failed to update user info.',
    });
  }
}

function* verifyEmail({ payload }) {
  try {
    const res = yield call(verifyEmailRequest, payload);

    if (res && res.status) {
      yield put({ type: AUTH_VERIFY_EMAIL_SUCCESS });
      window.location.href = '/programs';
    } else {
      throw new Error();
    }
  } catch (err) {
    yield put({
      type: AUTH_VERIFY_EMAIL_FAILED,
      error: 'Verification failed.',
    });
  }
}

export function* watchAuth() {
  yield takeLatest(AUTH_SIGN_IN_INIT, signIn);
  yield takeLatest(AUTH_SIGN_UP_INIT, signUp);
  yield takeLatest(AUTH_STRIPE_CONNECT_INIT, stripeOAuth);
  yield takeLatest(UPDATE_USER_INIT, updateUser);
  yield takeLatest(AUTH_VERIFY_EMAIL_INIT, verifyEmail);
  yield takeLatest(AUTH_IMPERSONATE_INIT, impersonate);
}
